// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"cdc6cd47","832":"00fef473"}[chunkId] + ".chunk.js";
};